import React, { useEffect } from 'react'
import { Col, Container, Row } from 'reactstrap'
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getFrameworksList } from '../../../slices/Dhanush/ManageFrameworks/thunk';
import Loader from '../../../Components/Common/Loader';
import Error from '../../../Components/Common/Error';
import FrameworksTable from '../../../Components/Dhanush/ManageFrameworks/FrameworksTable';

export default function ManageFramework() {

     // Get Clients List
     const dispatch = useDispatch();
     const { isLoading, isError, data } = useSelector(state => state.FrameworksList);
 
     const refreshComponent = () => {
         dispatch(getFrameworksList());
     };
 
     useEffect(() => {
         dispatch(getFrameworksList());
     }, [dispatch]);

     if (isLoading) return <Loader />;
     if (isError) return <Error />;

     
    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Manage Framework'} pageTitle={"Dashboard"} />

                    <Row>
                        <Col lg={12}>
                            <FrameworksTable data={data} refreshComponent={refreshComponent} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
